import React from 'react';
import { Puff } from 'react-loader-spinner';

function Spinner({ color = '#aaa' }) {
  return <Puff color={color} height={60} width={60} timeout={300000} />;
}
export default Spinner;
